import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-fuel",
  "use": "icon-ic-fuel-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"icon-ic-fuel\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5 3.135a2 2 0 0 0-2 2v14a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2v-6.42h1.17v3.432a2.585 2.585 0 0 0 5.168 0V7.774a1.05 1.05 0 0 0-.24-.67L18.94 4.498a1 1 0 1 0-1.541 1.275l1.94 2.344v8.031a.585.585 0 1 1-1.17 0v-4.372a1.06 1.06 0 0 0-1.06-1.06H15v-5.58a2 2 0 0 0-2-2H5Zm8 16H5v-14h8v14Zm-6-11a1 1 0 1 0 0 2h4a1 1 0 0 0 0-2H7Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol